
import React, { useContext, useState, useEffect, useRef } from 'react';

import moment from 'moment';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { _endPoints, getpaymenttype, setdeletebooking } from '../../Helper/links';
import pattern from '../../Helper/pattern';
import API from '../../Helper/server/API';
import count_days from '../../functions/count_days';
import sum_total_paid from '../../functions/sum_total_paid';
import sum_total_price from '../../functions/sum_total_price';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import { useWhatsapp } from '../../whatsapp/WhatsappContext';
import { InvoiceContext } from '../invoice/Invoice_Context';
import './views/invoices/invoice.css';
import { Skeleton } from 'primereact/skeleton';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Messages } from 'primereact/messages';

function DelReservations(reservation_type) {
    const msgs = useRef(null);
    const { SendWhatsAppMsg } = useWhatsapp();
    const data = useContext(InvoiceContext)
    var monthView = 0;
    const customer = data?.customer
    const reservations = [...data.reservations].sort((a, b) =>
        a.date_check_in > b.date_check_in ? 1 : -1,
    );
    const [loading_paid, set_loading_delete] = useState(false);
    const [paid_delete, setPaid_delete] = useState(0);
    const handelDeletepaid = (e) => {
        if (
            (pattern.number_int.test(e.target.value) === true)
            && ((e.target.value * 1) === sum_total_paid(reservations))
        ) {
            document.getElementById("ldeletepaid").style.color = "black";
            setPaid_delete(e.target.value);
        }
        else {
            document.getElementById("ldeletepaid").style.color = "red";
        }
    }
    async function DeleteReservationes(e) {
        e.preventDefault();
        set_loading_delete(true);
        var test_validtion = true
        var msg = ''
        //_______________________________________________________________________________________
        //                         Validtion
        if (sum_total_paid(reservations) > 0) {
            if (!(paymentmethod && paymentmethod?.id_payment_type && pattern.number_int.test(paymentmethod?.id_payment_type))) {
                const lpayment_typeElem = document?.getElementById("lpayment_type");
                if (lpayment_typeElem) {
                    lpayment_typeElem.style.color = 'red';
                }
                msg = 'أرجــو إختيــار طريقــة الدفـع'
                test_validtion = false;
            }
            else if (pattern.number_int.test(paid) === false
                || paid !== sum_total_paid(reservations)) {
                const lpaidElem = document?.getElementById("lpaid");
                if (lpaidElem) {
                    lpaidElem.style.color = 'red';
                }
                msg = 'أرجــو إدخــال قيــمة المستــرجعــة يطـريقة صحيحــة'
                test_validtion = false;
            }
        }
        if (reservations.length === 0) {
            // document.getElementById("lReservationes").style.color = 'red';
            msg = 'أرجــو إختيــار الحجــوزات'
            test_validtion = false;
        }
        //_______________________________________________________________________________________
        if (test_validtion) {
            var data_send = {
                id_customer: customer?.ID_customer ?? null,
                reservations: reservations,
                payment_type: paymentmethod,
                paid: paid,
            }
            let response;
            if (reservation_type?.reservation_type === 'service') {
                response = await API.post(_endPoints.reservations.services.delete, data_send)
            }
            else {
                response = await API.post(_endPoints.reservations.delete, data_send)
            }
            if (response?.success) {
                if (customer?.ID_customer) {
                    SendWhatsAppMsg(_endPoints.whatsapp.new_booking, {
                        ID_customer: customer?.ID_customer,
                        status_booking: "delete"
                    })
                }
                setPaid_delete(0);
                data.setViewDelete(false);
                data.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'success', summary: 'نجــاح', detail: response.msg
                })
                data.GetReservationesComing();
                data.setSelectedReservationes([]);
                data.setDataPaid(response);
                data.setInvoiceDelete(true);
            }
            else if (response?.success === 0) {
                data?.toast?.current?.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response.msg
                });
            }
        }
        else {
            data.toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: "ارجو إدخال  قيمة المسترجعة صحيحة"
            })
        }
        set_loading_delete(false);
    }

    const [paid, setpaid] = useState(0);
    const [loading_get_payment_type, set_loading_get_payment_type] = useState(true)
    const [payment_types, set_get_payment_types] = useState([])
    const [paymentmethod, set_paymentmethod] = useState(null);
    const view_paymentmethod = (e) => {
        if (paymentmethod?.name_payment_type) {
            return <span style={{ fontFamily: "Cairo" }}>{paymentmethod?.name_payment_type}</span>
        }
        else {
            return <span style={{ fontFamily: "Cairo" }}>-</span>
        }
    }
    const handelpaid = (e) => {
        if (
            (pattern.number_int.test(e.target.value) === true)
            && ((e.target.value * 1) === sum_total_paid(reservations))
        ) {
            setpaid(e.target.value);
            document.getElementById("lpaid").style.color = "black";
        }
        else {
            setpaid(null);
            document.getElementById("lpaid").style.color = "red";
        }
    }
    const handel_paymentmethod = (e) => {
        if (pattern.number_int.test(e.value?.id_payment_type)) {
            set_paymentmethod(e.value)
            document.getElementById("lpayment_type").style.color = "black";
            if (e.value === 2) {
                if (msgs && msgs.current) {
                    msgs.current.clear();
                    msgs?.current?.show([
                        {
                            sticky: true, severity: 'warn', summary: 'تــحذيــر', detail: 'لايمــكن إلغــاء الحجــز عنــد دفــع عن طريــق  الدفــع الإلكتــروني', closable: false,
                            style: {
                                fontFamily: "Cairo",
                                fontSize: "1rem",
                                padding: "1rem"
                            },
                        },
                    ]);
                }
            }
            else {
                if (msgs && msgs.current) {
                    msgs.current.clear();
                }
            }
        }
        else {
            document.getElementById("lpayment_type").style.color = "red";
        }
    }
    const handel_paymentmethod_value_key = (e) => {
        set_paymentmethod({ ...paymentmethod, value_key: e.target.value })
        if (
            paymentmethod?.pattern_kay &&
            new RegExp('^' + paymentmethod?.pattern_kay + '$').test(e.target.value)
        ) {
            document.getElementById("lvalue_key").style.color = "black";
        } else {
            document.getElementById("lvalue_key").style.color = "red";
        }
    }
    const handel_paymentmethod_value_key_2 = (e) => {
        set_paymentmethod({ ...paymentmethod, value_key_2: e.target.value })
        if (
            paymentmethod?.pattern_kay_2 &&
            new RegExp('^' + paymentmethod?.pattern_kay_2 + '$').test(e.target.value)
        ) {
            document.getElementById("lvalue_key_2").style.color = null;
        } else {
            document.getElementById("lvalue_key_2").style.color = "red";
        }
    }

    const GetPaymentType = async () => {
        set_loading_get_payment_type(true);
        const response = await API.get(`${getpaymenttype}?state=1`)
        if (response?.success === 1) {
            set_get_payment_types(response.data);
        }
        set_loading_get_payment_type(false);
    }
    useEffect(() => {
        GetPaymentType()
    }, [])
    return (
        <div>
            <div id="invoice" className="page-content fade-in-up" dir="rtl" style={{ margin: "auto", maxWidth: "900PX" }}  >
                <div className="ibox invoice-print">
                    <div className="invoice-header">
                        <hr></hr>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6" style={{ borderLeft: "1px solid rgba(0,0,0,.1" }}>
                                    <div className="m-b-5 font-bold" >بيانات الزبون</div>
                                    <ul className="list-unstyled m-t-10">
                                        <li className="m-b-5">
                                            <span className="font-strong"> الأسم  :</span> {customer.visitor_name ? customer.visitor_name : null} </li>
                                        <li className="m-b-5">
                                            <span className="font-strong"> الهاتف :</span> {customer.phone_number ? customer.phone_number : null}</li>
                                        {customer.whatsapp_number ?
                                            (<li className="m-b-5" > <span className="font-strong" > واتس اب :</span> {customer.whatsapp_number}</li>)
                                            : (null)
                                        }
                                    </ul>
                                </div>

                                <div className="col-6" style={{ borderRight: "1px solid rgba(0,0,0,.1" }}>
                                    <div className="m-b-5 font-bold">بيانات الحجوزات</div>
                                    <ul className="list-unstyled m-t-10">
                                        <li className="m-b-5">
                                            <span className="font-strong"> عدد الحجوزات : </span> {reservations.length} </li>
                                        <li className="m-b-5">
                                            <span className="font-strong">  إجمالي الأيام : </span>  {count_days(reservations)}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                    <div class="table-responsive">
                        <table className="table table-bordered table-striped no-margin table-invoice">
                            <thead className="color-view bg-ebony">
                                <tr style={{ color: "white", fontSize: "10px" }}>
                                    <th>الحجز</th>
                                    <th>الاقامة</th>
                                    <th>الأيام</th>
                                    <th colSpan={2} style={{ textAlign: "center" }} >
                                        الدخول - الخروج
                                    </th>
                                    <th>سعر اليـوم</th>
                                    <th>الإجمالي</th>
                                    <th >قيمة الخصم</th>
                                    <th >الإجمالي بعد الخصم</th>
                                    <th>المدفوع</th>
                                    <th>الباقي</th>
                                    <th style={{ textAlign: "center", width: "10%" }}>تاريخ  إلغاء </th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "13px" }} >
                                {
                                    reservations.map((res) => {
                                        return (
                                            <>
                                                {
                                                    monthView !== moment(res.date_check_in).format('MM') ?
                                                        (
                                                            <tr>
                                                                <td colSpan={12}>
                                                                    <center>
                                                                        <strong >
                                                                            {" حجوزات شهر "}
                                                                            {monthView = moment(res.date_check_in).format('MM')}
                                                                            {" " + moment(res.date_check_in).format('MMMM') + " "}
                                                                        </strong>
                                                                    </center>
                                                                </td>
                                                            </tr>
                                                        )
                                                        :
                                                        (null)
                                                }
                                                <tr>
                                                    <td>{res.ID_reservation}</td>
                                                    <td>
                                                        <div>
                                                            {
                                                                res.apartment?.type ?
                                                                    <>
                                                                        <small>{view_apartment_type_ar(res.apartment.type)}</small><strong>{"-" + res.apartment.number}</strong>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <small>{view_apartment_type_ar(res.type)}</small><strong>{"-" + res.number}</strong>
                                                                    </>
                                                            }
                                                        </div>
                                                        {
                                                            res.apartment?.number_people ?
                                                                <>
                                                                    <small>{res.apartment.number_people} أشخاص </small>
                                                                </>
                                                                :
                                                                <>
                                                                    <small>{res.number_people} أشخاص </small>
                                                                </>
                                                        }
                                                    </td>

                                                    <td style={{ width: "5s%" }}>{count_days([res])} أيام</td>
                                                    <td >
                                                        <div>
                                                            <strong >{res.date_check_in} </strong>
                                                        </div>
                                                        <small> {view_day_ar(res.date_check_in)} </small>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <strong>{res.date_check_out}  </strong>
                                                        </div>
                                                        <small>  {view_day_ar(res.date_check_out)} </small>
                                                    </td>
                                                    <td>{Intl.NumberFormat("en-US").format(res.price_day)}  د.ل</td>
                                                    <td><strong >{Intl.NumberFormat("en-US").format(res.total_price + res.discount_value)} د.ل</strong></td>
                                                    <td><strong >{Intl.NumberFormat("en-US").format(res.discount_value)} د.ل</strong></td>
                                                    <td ><strong >{Intl.NumberFormat("en-US").format(res.total_price)} د.ل</strong></td>
                                                    <td><strong >{Intl.NumberFormat("en-US").format(res.total_paid)} د.ل</strong></td>
                                                    <td>
                                                        {
                                                            res.total_price - res.total_paid === 0 ?
                                                                (
                                                                    <strong style={{ color: "green" }}>
                                                                        خالص
                                                                    </strong>
                                                                )
                                                                :
                                                                (
                                                                    <strong style={{ color: "red" }}>
                                                                        {Intl.NumberFormat("en-US").format(res.total_price - res.total_paid)} د.ل
                                                                    </strong>
                                                                )
                                                        }
                                                    </td>
                                                    <td >
                                                        {
                                                            res.date_del_reservation ?
                                                                <strong style={{ color: "red" }}>
                                                                    {moment(res.date_del_reservation).format('MM-DD')}
                                                                    <br></br>
                                                                    {moment(res.date_del_reservation).format('LT')}
                                                                </strong>
                                                                : "-"
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <table className="table no-border">
                        <thead >
                            <tr>
                                <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                                <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                                <td className="font-bold font-18 text-center">إجمالي المتبقي  </td>
                            </tr>
                        </thead>
                        <tbody  >
                            <tr>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{Intl.NumberFormat("en-US").format(sum_total_price(reservations))} د.ل</td>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{Intl.NumberFormat("en-US").format(sum_total_paid(reservations))} د.ل</td>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>
                                    {
                                        sum_total_price(reservations) - sum_total_paid(reservations) === 0 ?
                                            (
                                                <strong style={{ color: "green" }}>
                                                    خالص
                                                </strong>
                                            )
                                            :
                                            (
                                                <strong style={{ color: "red" }}>
                                                    {Intl.NumberFormat("en-US").format(sum_total_price(reservations) - sum_total_paid(reservations))} د.ل
                                                </strong>
                                            )
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <hr></hr>
                    {
                        sum_total_paid(reservations) > 0 ?
                            (
                                <center>
                                    {
                                        loading_get_payment_type ?
                                            <>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <center>
                                                            <label >طريقة الدفع</label>
                                                        </center>
                                                        <Skeleton width="100%" height='8rem' />
                                                    </div>

                                                </div>
                                            </>
                                            :
                                            <form>
                                                <div className="col-12 pb-4">
                                                    <div className="row">
                                                        <div className='col-12 col-md-12'>
                                                            <center>
                                                                <label htmlFor="ingredient1" id='lpayment_type'>طريقة الدفع</label>
                                                            </center>
                                                            <div className='row'>
                                                                <div className='col-12 col-md-12'>
                                                                    <Dropdown value={payment_types} onChange={(e) => handel_paymentmethod(e)} options={payment_types} optionLabel="name_payment_type" dir='rtl'
                                                                        placeholder="أختــار طريقــة الدفــع" className="col-12 col-md-12" style={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo" }}
                                                                        valueTemplate={view_paymentmethod} emptyMessage={<center>لا توجد خيارات متاحة</center>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr></hr>
                                                    {
                                                        paymentmethod && paymentmethod?.id_payment_type ?
                                                            <div className='row'>
                                                                <div className='col-6 col-md-6'>
                                                                    <h4 id="lpaid" >  قيمة المستــرجعـة</h4>
                                                                    {
                                                                        paymentmethod?.id_payment_type === 2 ?
                                                                            <div className="">
                                                                                <h4 style={{ color: "black" }}>
                                                                                    {Intl.NumberFormat("en-US").format((sum_total_price(reservations) - sum_total_paid(reservations) * 1) + ((paymentmethod?.commission / 100) * (sum_total_price(reservations) - sum_total_paid(reservations))))}  د.ل

                                                                                </h4>
                                                                                <label class="text-danger">
                                                                                    + عمولة {paymentmethod?.commission}%
                                                                                    ( {Intl.NumberFormat("en-US").format(((paymentmethod?.commission / 100) * (sum_total_price(reservations) - sum_total_paid(reservations))))} د.ل )
                                                                                </label>

                                                                            </div>

                                                                            :

                                                                            <>
                                                                                <InputNumber inputId="integeronly" onValueChange={(e) => handelpaid(e)}
                                                                                    style={{ textAlign: "center" }} min={0} maxLength={10} className='col-6' />
                                                                                <br></br>

                                                                                {
                                                                                    paymentmethod?.commission !== 0 ?
                                                                                        <>
                                                                                            <span class="text-danger mt-2">
                                                                                                + عمولة {paymentmethod?.commission}%
                                                                                                (
                                                                                                {paid <= sum_total_price(reservations) - sum_total_paid(reservations) ?
                                                                                                    <>{Intl.NumberFormat("en-US").format(((paymentmethod?.commission / 100) * (sum_total_price(reservations) - sum_total_paid(reservations))))} د.ل </> : <> - </>}
                                                                                                )
                                                                                            </span>
                                                                                            <h4 className='mt-2' style={{ color: "black" }}>
                                                                                                {paid <= sum_total_price(reservations) - sum_total_paid(reservations) ?
                                                                                                    <>{Intl.NumberFormat("en-US").format((paid) + ((paymentmethod?.commission / 100) * (paid)))}  د.ل</> : <>-</>
                                                                                                }
                                                                                            </h4>
                                                                                        </>
                                                                                        : null
                                                                                }
                                                                            </>

                                                                    }
                                                                </div>
                                                                <div className='col-6 col-md-6'>
                                                                    <div className='row'>
                                                                        <div className='col-12 col-md-12'>
                                                                            {
                                                                                paymentmethod?.name_kay ?
                                                                                    <>
                                                                                        <label id='lvalue_key'>{paymentmethod?.name_kay}</label>
                                                                                        <br></br>
                                                                                        <InputText value={paymentmethod?.value_key} onChange={(e) => handel_paymentmethod_value_key(e)} maxLength={200} id="value_key" placeholder={`ادخــال ${paymentmethod?.name_kay}`} className='col-md-12' ></InputText>

                                                                                    </>
                                                                                    : null
                                                                            }
                                                                        </div>
                                                                        <div className='col-12 col-md-12'>
                                                                            {
                                                                                paymentmethod?.name_kay_2 ?
                                                                                    <>
                                                                                        <label id='lvalue_key_2'>{paymentmethod?.name_kay_2}</label>
                                                                                        <br></br>
                                                                                        <InputText value={paymentmethod?.value_key_2} onChange={(e) => handel_paymentmethod_value_key_2(e)} maxLength={200} id="value_key_2" placeholder={`ادخــال ${paymentmethod?.name_kay_2}`} className='col-md-12' ></InputText>

                                                                                    </>
                                                                                    : null
                                                                            }
                                                                        </div>

                                                                    </div>
                                                                </div>


                                                                <div className='col-12 col-md-12'>
                                                                    <Messages ref={msgs} />
                                                                </div>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                                <div className="col-md-12 form-group">
                                                    <div className="text-center">
                                                        <Button label="إلغاء" raised severity="danger" style={{ fontFamily: "Cairo" }} onClick={() => data.setViewDelete(false)} />
                                                        <Button label=" إلغــاء الحجــز " raised severity="success" onClick={(e) => DeleteReservationes(e)}
                                                            loading={loading_paid} autoFocus
                                                            style={{ fontFamily: "Cairo", direction: "ltr", marginRight: "10px" }}
                                                        />
                                                    </div>
                                                </div>

                                            </form>
                                    }
                                </center>
                            )
                            :
                            <div className="col-md-12 form-group">
                                <div className="text-center">
                                    <Button label="إلغاء" raised severity="danger" style={{ fontFamily: "Cairo" }} onClick={() => data.setViewDelete(false)} />
                                    <Button label=" إلغــاء الحجــز " raised severity="success" onClick={(e) => DeleteReservationes(e)}
                                        loading={loading_paid} autoFocus
                                        style={{ fontFamily: "Cairo", direction: "ltr", marginRight: "10px" }}
                                    />
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}
export default DelReservations;